module.exports = __webpack_public_path__ + "static/media/RA32.36e835c1.gif";